import { YesNo } from '../../../../../types/api';
import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { genericRequiredFieldError } from '../../constants';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: {
    systemPowerSingleOrMultipleUsers,
    systemPowerTaxEquityPartnering,
    systemPowerTaxEquityFundingPercentage,
    systemPowerCommunityOrPPALease,
  },
} = loanFormModel;

export class TaxEquityFundingPercentageValidation implements ValidationSchema {
  public name: string = systemPowerTaxEquityFundingPercentage.name;
  public label: string = systemPowerTaxEquityFundingPercentage.label;
  public dependsOn: string[] = [
    systemPowerSingleOrMultipleUsers.name,
    systemPowerCommunityOrPPALease.name,
    systemPowerTaxEquityPartnering.name,
  ];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  when(
    singleOrMultipleUsers: string,
    communityOrPPALease: string,
    taxEquityPartnering: YesNo,
    schema
  ) {
    if (
      (singleOrMultipleUsers === 'Single User' ||
        (singleOrMultipleUsers === 'Multiple Users' &&
          communityOrPPALease === 'PPA/Lease Agreement')) &&
      taxEquityPartnering === 'Yes'
    ) {
      return schema.required(genericRequiredFieldError);
    }
    return schema;
  }
}
export default new Validation(new TaxEquityFundingPercentageValidation());
